/** The string trimmed, or undefined when it is not a string or is blank. @public */
export function nonEmptyText(value: unknown): string | undefined {
  return typeof value === "string" && value.trim() ? value.trim() : undefined;
}

/** True for a string with at least one non-whitespace character. @public */
export function hasText(value: unknown): value is string {
  return nonEmptyText(value) !== undefined;
}

/** "1 day", "3 days", "1,234 bytes". @public */
export function plural(n: number, one: string, many = `${one}s`): string {
  return `${n.toLocaleString("en-US")} ${n === 1 ? one : many}`;
}
